import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/services", label: "Services" },
    { path: "/workshops", label: "Workshops" },
    { path: "/blogs", label: "Blogs" },
  ];

  return (
    <>
      <nav className="w-full px-4 py-4 md:px-12 xl:px-16">
        <div className="flex items-center justify-between">
          {/* Left: Logo + Name */}
          <Link
            to="/"
            className="text-primary flex items-center space-x-2 text-xl font-bold xl:text-4xl"
          >
            <img
              src="/assets/images/biostat-logo.svg"
              alt="BioStat Logo"
              className="h-12 w-12 md:h-20 md:w-20"
            />
            <span className="text-dark">BioStat</span> <span>House</span>
          </Link>

          {/* Right: Navigation Links (Desktop only) */}
          <div className="hidden space-x-6 xl:flex">
            {navItems.map(({ path, label }) => (
              <NavLink
                key={path}
                to={path}
                className={({ isActive }) =>
                  `text-xl font-medium transition duration-200 ${
                    isActive
                      ? "text-primary border-primary rounded-lg border-b-2"
                      : "hover:text-primary text-dark hover:border-primary rounded-lg hover:border-b-2"
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
          </div>

          {/* Mobile Toggle Button */}
          <button
            className="text-dark relative z-50 text-4xl xl:hidden"
            onClick={() => setIsOpen(!isOpen)}
            aria-label={isOpen ? "Close menu" : "Open menu"}
          >
            {isOpen ? (
              <HiOutlineX className="text-dark" />
            ) : (
              <HiOutlineMenu className="text-dark" />
            )}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 backdrop-blur-md xl:hidden">
          <div className="w-11/12 max-w-sm space-y-6 p-6 text-center">
            {navItems.map(({ path, label }) => (
              <NavLink
                key={path}
                to={path}
                onClick={() => setIsOpen(false)}
                className={({ isActive }) =>
                  `block text-2xl font-semibold transition ${
                    isActive
                      ? "text-primary"
                      : "text-dark hover:text-primary hover:underline"
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
